export function safeRedirectPath(candidate: string | null | undefined, fallback: string): string {
	if (!candidate) {
		return fallback
	}

	try {
		const resolved = new URL(candidate, window.location.origin)
		if (resolved.origin !== window.location.origin) {
			return fallback
		}
		return `${resolved.pathname}${resolved.search}${resolved.hash}`
	} catch {
		return fallback
	}
}
